
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

@Component({
  name: "BaseCenteredCard",
})
export default class BaseCenteredCard extends Vue {
  @Prop({ default: null }) readonly title!: string;

  @Prop({ default: null }) readonly title1!: string;

  @Prop({ default: null }) readonly subtitle!: string;

  @Prop({ default: "font-size: 16px !important" })
  readonly fontSizeSubHeader!: string;
}
